import type { EliteList } from 'v2/interfaces/elite';

import { apiServiceProxy } from './api-proxy';

import type { ApiServiceProxy } from './api-proxy';

class EliteService {
  constructor(private readonly apiService: ApiServiceProxy) {}

  list = () => this.apiService.get<EliteList>('/elite').then((response) => response.data);
}

const eliteService = new EliteService(apiServiceProxy);
export default eliteService;
